<template>  
  <VUEModal :Titolo="this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_MOD_GRAFICHE',this.LinguaUtente)"
            :Programma="'DMSEW'"
            :Altezza="AltezzaPopup"
            :Larghezza="'400px'"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="ChiudiPopup" @onClickConfermaModal="ConfermaPopup">
    <template v-slot:Body>

      <VUEColorPicker :Popup="PopupColorPicker"
                      Programma="DMSEW"
                      :Colore="ColoreInModifica"
                      @OnClickConfermaPopup="ConfermaColore()"
                      @OnClickChiudiPopup="AnnullaColore()" />

      <div class="ZMSeparatoreScheda" style="margin-top: 0px">{{ this.GetTraduzioneLabel('VUEPopupColoriGraficaCatena','TKN_IMP_COLORE_GRAFICI',this.LinguaUtente) }}</div>

      <div class="ZMNuovaRigaScheda" style="display:flex;">
        <div class="ZMDivPopupContent" style="width: calc(100% - 10px); justify-content: left">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupColoriGraficaCatena','TKN_COLORE_PRINCIPALE',this.LinguaUtente) }}</label>
          <label class="form-control" style="width:60%; cursor: pointer" :style="{'background' : ObjGrafico.ColorePrincipale}" @click="ApriPopupColorPicker(ObjGrafico.ColorePrincipale, 'ColorePrincipale')">&nbsp;</label>
        </div>
      </div>

      <div class="ZMNuovaRigaScheda" style="display:flex;">
        <div class="ZMDivPopupContent" style="width: calc(100% - 10px); justify-content: left">
          <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupColoriGraficaCatena','TKN_SFONDO_GRAFICI',this.LinguaUtente) }}</label>
          <label class="form-control" style="width:60%; cursor: pointer" :style="{'background' : ObjGrafico.Background}" @click="ApriPopupColorPicker(ObjGrafico.Background, 'Background')">&nbsp;</label>
        </div>
      </div>

    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:30%" @click="ChiudiPopup" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:30%" @click="ConfermaPopup" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
</template>

<script>

import { SystemInformation } from '@/SystemInformation';
import VUEColorPicker from '@/utils/VUEColorPicker.vue';
import VUEModal from '@/utils/VUEModal.vue';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

export default 
{
  mixins: [ MixInsGestioneTraduzioni ],
  data()
  {
   return {
            PopupColorPicker       : false,
            ColoreInModifica       : {},
            ListaMarkup            : SystemInformation.TipiMarkup,
            LinguaUtente           : SystemInformation.UserInformation.Lingua
          }
  },
  props : ['AltezzaPopup', 'ObjGraficaCatena'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  components: { VUEModal, VUEColorPicker },
  methods :
  {
    ApriPopupColorPicker(Colore, TipoColore)
    {
      this.ColoreInModifica.Colore = Colore
      this.ColoreInModifica.Tipo = TipoColore
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      switch (this.ColoreInModifica.Tipo)
      {
        case 'Background'       : this.ObjGrafico.Background       = this.ColoreInModifica.Colore; break;
        case 'ColorePrincipale' : this.ObjGrafico.ColorePrincipale = this.ColoreInModifica.Colore; break;
      }
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    ConfermaPopup()
    {
      this.$emit('OnClickConfermaPopup')
    },

    ChiudiPopup()
    {
      this.$emit('OnClickChiudiPopup')
    }
  },
  computed:
  {
    ObjGrafico:
    {
      get()
      {
        return this.ObjGraficaCatena
      }
    },

  }
}
</script>
